import React, {useEffect} from 'react';
import {Flex, Form, Input, Select} from "antd";
import {useTranslation} from "react-i18next";
import IntlMessage, {IntlMessageText} from "../../../../../../components/IntlMessage/IntlMessage";
import classes from "../../../Applications/application.module.css";
import {useCascadingSelects} from "../hooks/useCascadingSelects";

const Step2MainInfo = ({form, currentStep, data}) => {
    const {t} = useTranslation();
    const {
        educationFields,
        filteredTrainDirections,
        filteredEduProgramGroups,
        partnerOrganizations,
        isLoadingData,
        handleEducationFieldSelect,
        handleTrainingDirectionSelect,
        loadAllData
    } = useCascadingSelects(form, data);

    useEffect(() => {
        // Загружаем данные только один раз
        if (educationFields.length === 0) {
            loadAllData();
        }
    }, []);

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={"small"}>
            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('educationField')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="educationField"
            >
                <Select
                    options={educationFields}
                    placeholder={IntlMessageText.getText({id: "educationField"})}
                    onSelect={handleEducationFieldSelect}
                    loading={isLoadingData}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('trainingDirection')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="trainingDirection"
            >
                <Select
                    options={filteredTrainDirections}
                    placeholder={IntlMessageText.getText({id: "trainingDirection"})}
                    onSelect={handleTrainingDirectionSelect}
                    loading={isLoadingData}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('groupEP')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="groupEP"
            >
                <Select
                    options={filteredEduProgramGroups}
                    placeholder={IntlMessageText.getText({id: "groupEP"})}
                    loading={isLoadingData}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('partnerOrg')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="partnerOrg"
            >
                <Select
                    options={partnerOrganizations}
                    placeholder={IntlMessageText.getText({id: "partnerOrg"})}
                    loading={isLoadingData}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('microqualPage.description') + " " + t('inRu')}
                labelCol={{span: 24}}
                name="mainDirectionRu"
                className={classes.formInputBlock}
            >
                <Input.TextArea
                    style={{height: 120}}
                    placeholder={IntlMessageText.getText({id: "microqualPage.description"})}
                    className={classes.formInput}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('microqualPage.description') + " " + t('inKz')}
                labelCol={{span: 24}}
                name="mainDirectionKz"
                className={classes.formInputBlock}
            >
                <Input.TextArea
                    style={{height: 120}}
                    placeholder={IntlMessageText.getText({id: "microqualPage.description"})}
                    className={classes.formInput}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('microqualPage.description') + " " + t('inEng')}
                labelCol={{span: 24}}
                name="mainDirectionEng"
                className={classes.formInputBlock}
            >
                <Input.TextArea
                    style={{height: 120}}
                    placeholder={IntlMessageText.getText({id: "microqualPage.description"})}
                    className={classes.formInput}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('goalEPMQ') + " " + t('inRu')}
                labelCol={{span: 24}}
                name="goalRu"
                className={classes.formInputBlock}
            >
                <Input.TextArea
                    style={{height: 120}}
                    className={classes.formInput}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('goalEPMQ') + " " + t('inKz')}
                labelCol={{span: 24}}
                name="goalKz"
                className={classes.formInputBlock}
            >
                <Input.TextArea
                    style={{height: 120}}
                    className={classes.formInput}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 1, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('goalEPMQ') + " " + t('inEng')}
                labelCol={{span: 24}}
                name="goalEng"
                className={classes.formInputBlock}
            >
                <Input.TextArea
                    style={{height: 120}}
                    className={classes.formInput}
                />
            </Form.Item>
        </Flex>
    );
};

export default Step2MainInfo;
